import {apiUrl, apiOption, apiResponse, errorResponse, only} from '../core/fetchz'
import loading from '../core/redux/loading'
import config from '../config'

const NAMESPACE = 'Workflow'
export const WORKFLOW_STREAM_LOADED = NAMESPACE + '/WorkflowStreamLoaded'
export const NEXT_STEP_LOADED = NAMESPACE + '/NextStepLoaded'
export const NEXT_STEP_QUERIED = NAMESPACE + '/NextStepQueried'
export const TODO_STREAM_LOADED = NAMESPACE + '/TodoStreamLoaded'
export const TODO_STATUS_QUERIED = NAMESPACE + '/TodoStatusQueried'
export const TODO_CRITERIA_RESET = NAMESPACE + '/TodoCriteriaReset'
export const CREATE_WORKFLOW_ACTION_SENT = NAMESPACE + '/CreateWorkflowActionSent'
export const REMOVE_WORKFLOW_ACTION_SENT = NAMESPACE + '/RemoveWorkflowActionSent'
export const UPDATE_WORKFLOW_LABEL_ACTION_SENT = NAMESPACE + '/UpdateWorkflowLabelActionSent'
export const UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT = NAMESPACE + '/UpdateIdentifiedRequestsActionSent'
export const ADD_STEP_ACTION_SENT = NAMESPACE + '/AddStepActionSent'
export const REMOVE_STEP_ACTION_SENT = NAMESPACE + '/RemoveStepActionSent'
export const UPDATE_STEP_ACTION_SENT = NAMESPACE + '/UpdateStepActionSent'
// form actions
export const TODO_CRITERIA_UPDATED = NAMESPACE + '/TodoCriteriaUpdated'
export const CREATE_WORKFLOW_ACTION_UPDATED = NAMESPACE + '/CreateWorkflowActionUpdated'
export const UPDATE_WORKFLOW_LABEL_ACTION_UPDATED = NAMESPACE + '/UpdateWorkflowLabelActionUpdated'
export const UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED = NAMESPACE + '/UpdateIdentifiedRequestsActionUpdated'
export const ADD_STEP_ACTION_UPDATED = NAMESPACE + '/AddStepActionUpdated'
export const UPDATE_STEP_ACTION_UPDATED = NAMESPACE + '/UpdateStepActionUpdated'
export const UPDATE_STEP_ACTION_RESET = NAMESPACE + '/UpdateStepActionReset'

export const DEFAULT_QUERY = {
    range: {offset: 0, limit: 19}
}

export const DEFAULT_TODO_QUERY = {
    ...DEFAULT_QUERY
}

export function loadWorkflowStream(companyId) {
    return loading((state) => {
        const {company} = state.company

        companyId = companyId || company.uid

        return fetch(config.api.url + '/clientcompanies/' + companyId + '/workflows', apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: WORKFLOW_STREAM_LOADED,
                stream: json.result
            }
        })
    }, WORKFLOW_STREAM_LOADED)
}

export function queryNextStep(ticketId) {
    return loadNextStep(ticketId, NEXT_STEP_QUERIED)
}

export function loadNextStep(ticketId, action) {
    return loading((state) => {
        const {ticket} = state.ticket

        ticketId = ticketId || ticket.uid

        return fetch(config.api.url + '/tickets/' + ticketId + '/nextstep', apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: action || NEXT_STEP_LOADED,
                nextStep: json
            }
        })
        .catch(only(404, (error) => {
            return {
                type: action || NEXT_STEP_LOADED,
                nextStep: null
            }
        }))
    }, action || NEXT_STEP_LOADED)
}

export function loadTodoStream(todoQuery) {
    return loading((state) => {
        const {query} = state.workflow.todo

        todoQuery = {
            ...DEFAULT_TODO_QUERY,
            ...query,
            ...todoQuery
        }

        return fetch(apiUrl(config.api.url + '/todolist', todoQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: TODO_STREAM_LOADED,
                range: headers.contentRange,
                stream: json.result,
                aggregations: json.aggregations,
                query: todoQuery
            }
        })
    }, TODO_STREAM_LOADED)
}

export function queryTodoStatus(actor) {
    const query = {
        range: {offset: 0, limit: 0},
        actor: actor
    }

    return loading(fetch(apiUrl(config.api.url + '/todolist', query), apiOption())
    .then(apiResponse)
    .then(({headers, json}) => {
        return {
            type: TODO_STATUS_QUERIED,
            status: json.aggregations.expectedDateStatus
        }
    }), TODO_STATUS_QUERIED)
}

export function sendCreateWorkflowAction() {
    return loading((state) => {
        const {company} = state.company
        const {createWorkflowAction} = state.workflow

        const option = {
            method: 'PATCH',
            body: {
                action: 'CreateWorkflow',
                ...createWorkflowAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/workflows', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: CREATE_WORKFLOW_ACTION_SENT,
                workflowUid: json.uid
            }
        })
    }, CREATE_WORKFLOW_ACTION_SENT)
}

export function sendRemoveWorkflowAction(workflowId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'RemoveWorkflow',
                workflowUid: workflowId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/workflows', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_WORKFLOW_ACTION_SENT
            }
        })
    }, REMOVE_WORKFLOW_ACTION_SENT)
}

export function sendUpdateWorkflowLabelAction(workflowId) {
    return loading((state) => {
        const {company} = state.company
        const {updateWorkflowLabelAction} = state.workflow

        const option = {
            method: 'PATCH',
            body: {
                action: 'UpdateWorkflowLabel',
                workflowUid: workflowId,
                ...updateWorkflowLabelAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/workflows', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_WORKFLOW_LABEL_ACTION_SENT
            }
        })
    }, UPDATE_WORKFLOW_LABEL_ACTION_SENT)
}

export function sendUpdateIdentifiedRequestsAction(workflowId) {
    return loading((state) => {
        const {company} = state.company
        const {updateIdentifiedRequestsAction} = state.workflow
        const {identifiedRequests, ...action} = updateIdentifiedRequestsAction

        const option = {
            method: 'PATCH',
            body: {
                action: 'UpdateIdentifiedRequests',
                workflowUid: workflowId,
                identifiedRequests: identifiedRequests.map((ir) => ir.uid),
                ...action
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/workflows', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT
            }
        })
    }, UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT)
}

export function sendAddStepAction(workflowId) {
    return loading((state) => {
        const {company} = state.company
        const {addStepAction} = state.workflow

        const option = {
            method: 'PATCH',
            body: {
                action: 'AddStep',
                workflowUid: workflowId,
                ...addStepAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/workflows', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ADD_STEP_ACTION_SENT
            }
        })
    }, ADD_STEP_ACTION_SENT)
}

export function sendRemoveStepAction(workflowId, stepId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'RemoveStep',
                workflowUid: workflowId,
                stepUid: stepId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/workflows', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_STEP_ACTION_SENT
            }
        })
    }, REMOVE_STEP_ACTION_SENT)
}

export function sendUpdateStepAction(workflowId) {
    return loading((state) => {
        const {company} = state.company
        const {updateStepAction} = state.workflow

        const option = {
            method: 'PATCH',
            body: {
                action: 'UpdateStep',
                workflowUid: workflowId,
                ...updateStepAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/workflows', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_STEP_ACTION_SENT
            }
        })
    }, UPDATE_STEP_ACTION_SENT)
}

export function resetTodoCriteria(criteria) {
    return {
        type: TODO_CRITERIA_RESET,
        criteria: criteria
    }
}

export function updateUpdateIdentifiedRequestsAction(action) {
    return {
        type: UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED,
        action: action
    }
}

export function updateWorkflowLabelAction(action) {
    return {
        type: UPDATE_WORKFLOW_LABEL_ACTION_UPDATED,
        action: action
    }
}

export function updateAddStepAction(action) {
    return {
        type: ADD_STEP_ACTION_UPDATED,
        action: action
    }
}

export function resetUpdateStepAction(action) {
    return {
        type: UPDATE_STEP_ACTION_RESET,
        action: action
    }
}


// WEBPACK FOOTER //
// ./lib/workflow/actions.js